import { render, staticRenderFns } from "./StepUpNotification.vue?vue&type=template&id=d6c5a406&"
import script from "./StepUpNotification.vue?vue&type=script&lang=js&"
export * from "./StepUpNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports